export const travellerDetailsForm = [
  {
    id: 1,
    name: "name",
    type: "text",
    label: "Name",
    placeHolder: "Enter Name",
  },
  {
    id: 2,
    name: "age",
    type: "number",
    label: "Age",
    placeHolder: "Enter Age",
  },
];

export const contactDetailsForm = [
  {
    id: 1,
    name: "emailId",
    type: "email",
    label: "Email Id",
    placeHolder: "Enter email id",
  },
  {
    id: 2,
    name: "mobileNo",
    type: "number",
    label: "Mobile No",
    placeHolder: "Enter mobile no",
  },
];
